export default __webpack_public_path__ + "static/media/phcnIbd.efe0c0be.svg";